/**
 * 权限
 */
enum Authority {
    /** 订单列表 */
    ROLE_ORDER_LIST = "ROLE_ORDER_LIST",

    /** 快速查单 */
    ROLE_ORDER_SEARCH = "ROLE_ORDER_SEARCH",

    /** 售后管理 */
    ROLE_REFUND_LIST = "ROLE_REFUND_LIST",

    /** 售后处理 */
    ROLE_REFUND_MANAGEMENT = "ROLE_REFUND_MANAGEMENT",

    /** 订单打印 */
    ROLE_ORDER_PRINT = "ROLE_ORDER_PRINT",

    /** 订单导入 */
    ROLE_ORDER_IMPORT = "ROLE_ORDER_IMPORT",

    /** 订单导出 */
    ROLE_ORDER_EXPORT = "ROLE_ORDER_EXPORT",

    /** 快递运单号导出 */
    ROLE_WAYBILL_EXPORT = "ROLE_WAYBILL_EXPORT",

    /** 账号权限管理 */
    ROLE_USER_MANAGEMENT = "ROLE_USER_MANAGEMENT",

    /** 店铺管理 */
    ROLE_SHOP_MANAGEMENT = "ROLE_SHOP_MANAGEMENT",

    /** 商品列表 */
    ROLE_PRODUCT_LIST = "ROLE_PRODUCT_LIST",

    /** 操作日志 */
    ROLE_ORDER_OP_LOG = "ROLE_ORDER_OP_LOG",

    /** 系统管理员 */
    ROLE_SYSTEM_ADMIN = "ROLE_SYSTEM_ADMIN",

    /** 管理后台-运营 */
    ROLE_ADMIN_OM = "ROLE_ADMIN_OM",

    /** 管理后台-客服 */
    ROLE_ADMIN_CS = "ROLE_ADMIN_CS",

    /** 分销退款相关 */
    ROLE_DROP_SHIPPING_REFUND_MANAGEMENT = "ROLE_DROP_SHIPPING_REFUND_MANAGEMENT",

    /** 自动打印 */
    ROLE_AUTO_PRINT = "ROLE_AUTO_PRINT",

    /** 查看明文 */
    ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT = "ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT",
}

export default Authority;
